import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CreelMap} from '@domain/textile-data/creel/creel-map';
import {OverviewListCreel} from '@presentation/pages/textile-data/creel/overview/overview-list-creel';
import {cloneDeep} from 'lodash-es';

@Component({
  selector: 'app-edit-creel-mapping',
  templateUrl: './edit-creel-mapping.component.html'
})
export class EditCreelMappingComponent {
  @Output() public closeEditCreelMapping: EventEmitter<void> = new EventEmitter<void>();
  @Output() public saveCreelMapping: EventEmitter<CreelMap[]> = new EventEmitter<CreelMap[]>();

  private _creel: OverviewListCreel;

  @Input() public set creel(creel: OverviewListCreel) {
    this._creel = cloneDeep(creel);
  }

  public get creel(): OverviewListCreel {
    return this._creel;
  }

  public close(): void {
    this.closeEditCreelMapping.emit();
  }

  public save(): void {
    this.saveCreelMapping.emit(this.creel.mappingForCurrentPositionOnMachine);
  }
}
